import "core-js/modules/es.object.assign";
export var composeValidators = function composeValidators() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return function (formData, props) {
    return validators.reduce(function (errors, validator) {
      return Object.assign(validator(formData, props) || {}, errors);
    }, {});
  };
};